import _get from 'lodash/get';
import {
  GET_INDENTS_LIST,
  GET_EMAILS_LIST,
  SAVE_FILTERS,
  RESET_TABLE,
  UPDATE_TAB,
  ASSIGN_INDENT,
  UNTICK_FLAGS,
  GET_HEADER_DETAILS,
  VIEW_FREIGHT,
  CLEAR_VIEW_FILE,
  FETCH_EXPIRE_REASON,
  EXPIRE_INDENT,
  RESET_EXPIRE_INDENT,
  GET_CONSIGNER_CODES,
  GET_DISTRICT_LIST,
  SET_SELECTED_ORIGIN_FILTERS,
  SET_SELECTED_DESTN_FILTERS,
} from './placement.actions';

import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';

const initialPlacementData = {
  PENDING: {
    list: [],
    count: null,
  },
  FULFILLED: {
    list: [],
    count: null,
  },
  EXPIRED: {
    list: [],
    count: null,
  },
};
const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);

const applyPreSelectedFilters = (dataArray, selectedArray = []) => {
  return dataArray.map((item) => ({
    ...item,
    selected: selectedArray.some((selectedItem) => selectedItem.key === item.key),
  }));
};
const defaultState = {
  indents: [],
  indentCount: null,
  indentAssigned: false,
  createdBy: null,
  consignerCodes: [],

  filterObject: {
    consignerTypes: [],
    indentLoadingTime: {
      key: '',
      name: '',
      value: {
        from: '',
        to: '',
      },
    },
    subStage: [],
    consignerCodes: [],
    createdBy: [],
    assignedTo: [],
    kycStatus: '',
    bodyType: null,
    tyreCount: null,
    sizeInFt: null,
    origin: '',
    destination: '',
  },
  selectedTab: 0,
  headerDetails: {},
  freightViewLink: '',
  currentStateContext: '',
  placementData: { ...initialPlacementData },
  createdByEmailsList: [],
  assignedToEmailsList: [],
  originDistricts: [],
  destinationDistricts: [],
  selectedOriginFilters: [],
  selectedDestinationFilters: [],
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_INDENTS_LIST[REQUEST]:
      return { ...state };
    case GET_INDENTS_LIST[SUCCESS]: {
      let type = action.params.status;
      let listData = action.response.indents || [];
      let count = action.response.count || 0;
      let newListObj = {};
      if (type) {
        newListObj = { ...state.placementData[`${type}`] };
        newListObj.list = newListObj.list.length ? newListObj.list.concat(listData) : listData;
        newListObj.count = count;
        state.placementData[type] = newListObj;
      }

      return {
        ...state,
        indents: (action.response.indents !== null && state.indents.concat(action.response.indents)) || state.indents,
        indentCount: (action.response.count && action.response.count) || null,
        createdBy: (action.response.defaultFilter && action.response.defaultFilter) || null,
      };
    }

    case GET_CONSIGNER_CODES[REQUEST]:
      return { ...state, consignerCodes: [] };
    case GET_CONSIGNER_CODES[SUCCESS]:
      return {
        ...state,
        consignerCodes: {
          consigners: action.response.consigners ?? [],
          count: action.response.count,
        },
      };

    case GET_EMAILS_LIST[REQUEST]:
      return { ...state };
    case GET_EMAILS_LIST[SUCCESS]: {
      if ((action?.params?.type ?? '') === 'CREATED_BY') {
        return { ...state, createdByEmailsList: action.response.users };
      } else {
        return { ...state, assignedToEmailsList: action.response.users };
      }
    }

    case GET_DISTRICT_LIST[REQUEST]:
      return { ...state };
    case GET_DISTRICT_LIST[SUCCESS]:
      return {
        ...state,
        [action.params === 'originDistrict' ? 'originDistricts' : 'destinationDistricts']: applyPreSelectedFilters(
          action.response ?? [],
          action.params === 'originDistrict' ? state.selectedOriginFilters : state.selectedDestinationFilters,
        ),
      };
    case SET_SELECTED_ORIGIN_FILTERS:
      return {
        ...state,
        selectedOriginFilters: action.payload,
      };
    case SET_SELECTED_DESTN_FILTERS:
      return {
        ...state,
        selectedDestinationFilters: action.payload,
      };
    case ASSIGN_INDENT[REQUEST]:
      return { ...state, indentAssigned: false };
    case ASSIGN_INDENT[SUCCESS]:
      return { ...state, indentAssigned: true, indents: [] };
    case SAVE_FILTERS:
      return { ...state, filterObject: action.filter };
    case UNTICK_FLAGS:
      return { ...state, indentAssigned: false };
    case RESET_TABLE:
      return { ...state, indents: [], placementData: { ...initialPlacementData } };
    case UPDATE_TAB:
      return { ...state, selectedTab: action.value, indentCount: null };
    case GET_HEADER_DETAILS[REQUEST]:
      return { ...state, headerDetails: {} };
    case GET_HEADER_DETAILS[SUCCESS]:
      return { ...state, headerDetails: action.response };
    case VIEW_FREIGHT[REQUEST]:
      return { ...state, freightViewLink: '' };
    case VIEW_FREIGHT[SUCCESS]:
      return { ...state, freightViewLink: action.response.viewUrl };
    case CLEAR_VIEW_FILE:
      return { ...state, freightViewLink: '' };
    case FETCH_EXPIRE_REASON[SUCCESS]:
      return { ...state, expiryReasons: action.response.reasons };
    case EXPIRE_INDENT[REQUEST]:
      return { ...state, demandExpired: false };
    case EXPIRE_INDENT[SUCCESS]:
      return { ...state, demandExpired: true };
    case EXPIRE_INDENT[FAILURE]:
      return { ...state, demandExpired: false };
    case RESET_EXPIRE_INDENT:
      return { ...state, demandExpired: false };
    default:
      return state;
  }
}

export const getPlacementReducer = (state) => state.placement.placementList;

export const getExpiryReasons = (state) => _get(state, 'placement.placementList.expiryReasons', []);

export const getDemandExpired = (state) => _get(state, 'placement.placementList.demandExpired', false);
export const getHeaderInformation = (state) => _get(state, 'placement.placementList.headerDetails', {});
